var map = {
	"./audio-placeholder": 679,
	"./audio-placeholder.png": 679,
	"./avatar-missing": 339,
	"./avatar-missing.png": 339,
	"./avatar-missing.svg": 967,
	"./header-missing": 511,
	"./header-missing.png": 511,
	"./soapbox-logo": 512,
	"./soapbox-logo-white": 513,
	"./soapbox-logo-white.svg": 513,
	"./soapbox-logo.svg": 512,
	"./video-placeholder": 680,
	"./video-placeholder.png": 680,
	"./void": 681,
	"./void.png": 681,
	"./web-push/web-push-icon_expand": 758,
	"./web-push/web-push-icon_expand.png": 758,
	"./web-push/web-push-icon_favourite": 759,
	"./web-push/web-push-icon_favourite.png": 759,
	"./web-push/web-push-icon_reblog": 760,
	"./web-push/web-push-icon_reblog.png": 760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 966;